var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "5902dff3-e0e0-42ce-8997-8fc0ce75c3a9"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "f8b659e9-ca8f-4bd2-bdb9-238db7b1d18a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.71 0 0 2.7 540 540.13)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1495.81, -1502.25)",
    d: "M 1369 2990 C 1111 2967 843 2867 627 2713 C 523 2639 361 2477 287 2373 C 161 2196 60 1955 24 1745 C 2 1612 2 1388 24 1255 C 60 1045 161 804 287 627 C 361 523 523 361 627 287 C 1029 0 1534 -71 2000 92 C 2345 214 2662 496 2832 833 C 2884 937 2944 1120 2966 1240 C 2990 1370 2990 1631 2967 1760 C 2911 2066 2771 2331 2546 2556 C 2333 2769 2113 2891 1824 2959 C 1743 2978 1530 3002 1475 2998 C 1464 2998 1416 2994 1369 2990 z M 1731 2884 C 2018 2836 2282 2699 2491 2491 C 2655 2326 2758 2160 2830 1941 C 2881 1787 2900 1667 2900 1500 C 2900 1118 2760 779 2491 509 C 2326 345 2160 242 1941 170 C 1787 119 1667 100 1500 100 C 1118 100 779 240 509 509 C 345 674 242 840 170 1059 C 119 1213 100 1333 100 1500 C 100 1882 240 2221 509 2491 C 716 2697 978 2834 1265 2884 C 1376 2904 1614 2904 1731 2884 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 -6.72 -3.91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1445.42, -1531.55)",
    d: "M 1218 2319 C 1206 2312 1200 2297 1200 2270 L 1200 2231 L 918 2228 C 600 2225 599 2224 536 2147 L 505 2108 L 502 1747 C 500 1548 502 1369 505 1351 C 510 1323 542 1285 656 1170 L 800 1024 L 800 969 C 801 808 954 698 1113 744 C 1218 775 1290 869 1290 978 L 1290 1030 L 1490 1030 L 1690 1030 L 1690 1430 L 1690 1829 L 2016 1832 L 2342 1835 L 2367 1864 C 2390 1891 2392 1900 2388 1955 C 2379 2064 2315 2156 2215 2202 C 2168 2224 2151 2225 1928 2228 L 1690 2231 L 1690 2270 C 1690 2299 1685 2312 1671 2320 C 1645 2333 1241 2333 1218 2319 z M 1281 1913 C 1291 1902 1295 1864 1295 1780 C 1295 1696 1291 1658 1281 1647 C 1269 1632 1240 1630 1044 1630 C 855 1630 819 1632 806 1646 C 783 1669 783 1891 806 1914 C 819 1928 855 1930 1044 1930 C 1240 1930 1269 1928 1281 1913 z M 1111 1052 C 1137 1028 1143 1016 1143 980 C 1143 944 1137 932 1111 908 C 1026 832 899 929 954 1029 C 985 1085 1061 1096 1111 1052 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 86.56 35.94)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-2145, -1232.71)",
    d: "M 1800 1323 C 1800 948 1802 912 1819 875 C 1871 763 1992 709 2113 744 C 2218 774 2290 869 2290 976 L 2290 1028 L 2366 1032 C 2435 1035 2445 1038 2466 1063 C 2489 1090 2490 1097 2490 1256 C 2490 1375 2486 1430 2476 1454 C 2463 1486 2360 1578 2221 1684 L 2167 1725 L 1983 1728 L 1800 1732 L 1800 1323 z M 2210 1505 L 2302 1430 L 2121 1430 L 1940 1430 L 1940 1505 L 1940 1580 L 2029 1580 L 2118 1580 L 2210 1505 z M 2111 1052 C 2137 1028 2143 1016 2143 980 C 2143 944 2137 932 2111 908 C 2026 832 1899 929 1954 1029 C 1985 1085 2061 1096 2111 1052 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRv);
export default __webpack_public_path__ + "static/media/rv.9cce3a9c95ce1b98a69d6aad68a3249c.svg";
export { ForwardRef as ReactComponent };